// eslint-disable-next-line no-restricted-imports
import React from "react";
import { isRsc } from "./reactVersion.js";
const fallback = current => ({
  current
});

/**
 * Create a ref that falls back to a plain object if `useRef` is not available.
 *
 * Only use this if the ref is optional and the component/hook is meant to
 * be used in client and server components.
 * @group React Hooks
 */
export const useRscCompatibleRef = isRsc ? fallback : React.useRef;